<template>
    <div class="pm ">
        <el-row class="video-tree position">

            <el-col :span="treespan"  style="height: 100%">
                <div class="grid-content bg-purple taskList">
                    <task-list ref="taskList" :tasklist="tasklist" @getValue="getValue"></task-list>
                </div>
            </el-col>
            <el-col :span="rightspan" class="position" style="height: 100%">
                <el-button icon="el-icon-arrow-left" class="icon right" @click="closeTree" v-show="isright"></el-button>
                <el-button icon="el-icon-arrow-right" class="icon left" @click="openTree" v-show="!isright"></el-button>
                <div class="grid-content bg-purple-light tabsList">
<!--                    <tabs-list ref="tabsList" :tabslist="tabslist" @refreshTask="refreshTask"></tabs-list>-->
                    <show-schedule ref="showSchedule" :showschedule="showschedule"></show-schedule>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    // import * as API from "./api"
    import TaskList from "./TaskList";
    import showSchedule from "./showSchedule";
    export default {
        name: "showschedule",
        components: {TaskList,showSchedule},
        data() {
            return {
                tasklist:{},
                //tabslist:{},
                showschedule:{},
                treespan:5,
                rightspan:19,
                isright:true,
            }
        },
        mounted() {
            this.$refs.showSchedule.getArrangementList();

        },
        methods: {

            getValue(data){
                //this.tabslist=data;
                this.showschedule=data;
                //console.log("从tree给到父index",this.showschedule);

            },
            refreshTask(data){
                //console.log("data???",data);
                this.tasklist=data;
                this.$refs.taskList.append(data);
            },
            closeTree(){
                this.treespan=0;
                this.rightspan=24;
                this.isright=false;
            },
            openTree(){
                this.treespan=5;
                this.rightspan=19;
                this.isright=true;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .pm{
        height: calc(100vh - 145px);
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 670px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 770px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 700px;
        }
    }*/

    //实现滚动功能
    /*.video-tree {
        overflow-y: auto;

    }*/
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }

</style>